import { defineComponent, ref } from 'vue'
import axios from '@/axios'
import { host } from '@/const'
import './style.sass'
import Preloader from '@/components/preloader/preloader.vue'

export default defineComponent({
  methods: {
    forceUpdate () {
      this.$forceUpdate()
    }
  },
  setup () {
    const preloader = ref(false)
    const formSend = ref<boolean>(false)
    const formMessage = ref<string>('')

    const logout = async () => {
      preloader.value = true
      try {
        const response = (await axios.post(`${host}/api/v1/clients/logout`, {}))
        if (response.data) {
          delete (localStorage.AuthClient)
          location.href = '/'
          formSend.value = response.data.message
        }
      } catch (error: any) {
        preloader.value = false
        formMessage.value = 'Произошла ошибка, попробуйте позже'
      }
    }

    return () => {
      return (
        <div>
          {preloader.value
            ? (
              <Preloader style="position: relative; margin: 28px auto;"/>
            )
            : (
              <div class="logout-lk" onClick={logout}>Выход из личного кабинета</div>
            )
          }
        </div>
      )
    }
  }
})